// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".country-row[data-v-282d18a4]{margin-bottom:-16px}", ""]);
// Exports
module.exports = exports;
